import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { ProgressBar } from 'primereact/progressbar';
import { Panel } from "primereact/panel";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from 'primereact/datatable';
import { Button } from "primereact/button";
import axios from "axios";

const PurchaseorderSupplierDndComponent = (props) => {

  const { t } = props;
  const { id } = useParams();

  const purchaseOrderIdFromRoute = id;
  const purchaseOrderId = props.purchaseOrderId || purchaseOrderIdFromRoute;
  const purchaseOrderSupplierId = props.purchaseOrderSupplierId || window.App.urlVars().purchaseorderSupplierId;
  const [supplierOrder, setSupplierOrder] = useState({});
  const [ordered, setOrdered] = useState(false);
  const [poItems, setPoItems] = useState([]);
  const [loadingPoItems, setLoadingPoItems] = useState(false);
  const [totalRecordsPoItems, setTotalRecordsPoItems] = useState(0);
  const [rowsPoItems, setRowsPoItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dtPoItems = useRef(null);
  const [draggingPoItemIds, setDraggingPoItemIds] = useState([]);
  const [dragOverSupplierTable, setDragOverSupplierTable] = useState(false);
  const [lazyParamsPoItems, setLazyParamsPoItems] = useState({
    first: 0,
    rows: rowsPoItems,
    page: 0,
    sortField: 'position',
    sortOrder: 1,
    filters: {}
  });

  const [selectedPoItems, setSelectedPoItems] = useState([]);

  const [supplierItems, setSupplierItems] = useState([]);
  const [loadingSupplierItems, setLoadingSupplierItems] = useState(false);
  const [totalRecordsSupplierItems, setTotalRecordsSupplierItems] = useState(0);
  const [rowsSupplierItems, setRowsSupplierItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dtSupplierItems = useRef(null);
  const [lazyParamsSupplierItems, setLazyParamsSupplierItems] = useState({
    first: 0,
    rows: rowsSupplierItems,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: {}
  });

  const [vatRates, setVatRates] = useState([]);
  const [loadingGlobal, setLoadingGlobal] = useState(false);
  const [purchaseOrderProjectId, setPurchaseOrderProjectId] = useState(null);
  const [projectItemOptions, setProjectItemOptions] = useState([]);

  const purchaseOrderStatus = props.purchaseOrderStatus;
  const isPoLocked = ['CLOSED', 'DELETED'].includes(
    String(purchaseOrderStatus || '').toUpperCase()
  );
  const isReadMode = props.mode === 'read' || window.App.urlVars().read === 'purchaseorder-supplier';
  const viewOnly = isReadMode || isPoLocked;

  const canEdit = !viewOnly;

  const pagerPoItems = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4) },
      ];
      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={(e) => setRowsPoItems(e.target.value)}
          appendTo={document.body}
        />
      );
    },
    'CurrentPageReport': (options) => (
      <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
        {options.first} - {options.last} / {options.totalRecords}
      </span>
    )
  };

  const pagerSupplierItems = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4) },
      ];
      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={(e) => setRowsSupplierItems(e.target.value)}
          appendTo={document.body}
        />
      );
    },
    'CurrentPageReport': (options) => (
      <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
        {options.first} - {options.last} / {options.totalRecords}
      </span>
    )
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const onPagePoItems = (event) => {
    let _lazyParams = { ...lazyParamsPoItems, ...event };
    setLazyParamsPoItems(_lazyParams);
  }
  const onSortPoItems = (event) => {
    let _lazyParams = { ...lazyParamsPoItems, ...event };
    setLazyParamsPoItems(_lazyParams);
  }
  const onFilterPoItems = (event) => {
    let _lazyParams = { ...lazyParamsPoItems, ...event };
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsPoItems(_lazyParams);
  }

  const onPageSupplierItems = (event) => {
    let _lazyParams = { ...lazyParamsSupplierItems, ...event };
    setLazyParamsSupplierItems(_lazyParams);
  }
  const onSortSupplierItems = (event) => {
    let _lazyParams = { ...lazyParamsSupplierItems, ...event };
    setLazyParamsSupplierItems(_lazyParams);
  }
  const onFilterSupplierItems = (event) => {
    let _lazyParams = { ...lazyParamsSupplierItems, ...event };
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsSupplierItems(_lazyParams);
  }

  let loadPoItemsTimeout = null;
  const loadPoItems = () => {
    if (!purchaseOrderId) return;
    setLoadingPoItems(true);
    if (loadPoItemsTimeout) {
      clearTimeout(loadPoItemsTimeout);
    }
    loadPoItemsTimeout = setTimeout(() => {
      const params = {
        ...lazyParamsPoItems,
        filters: {
          ...(lazyParamsPoItems.filters || {}),
          purchase_order: { value: purchaseOrderId, matchMode: 'equals' }
        }
      };
      let query = window.App.transformQueryParams(params);
      apiCall('get', '/api/v2/purchase-order-item' + query)
        .then(response => {
          setTotalRecordsPoItems(response.data.data.total_item_count);
          setPoItems(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingPoItems(false);
        })
    }, Math.random() * 1000 + 250);
  };

  const loadProjectItems = (projectId) => {
    if (!projectId) return;
    const params = {
      first: 0,
      rows: 9999,
      page: 0,
      sortField: 'name',
      sortOrder: 1,
      filters: {
        project: { value: projectId, matchMode: 'equals' },
      }
    };
    const query = window.App.transformQueryParams(params);
    apiCall('get', '/api/v2/project-item' + query)
      .then(res => {
        console.log('project-item response:', res.data.data);
        const items = res.data.data?.items || res.data.data || [];
        console.log('project-item items length:', Array.isArray(items) ? items.length : 'not array');
        setProjectItemOptions(items.map(i => ({ label: i.name, value: i.id, original: i })));
      })
      .catch(err => window.App.toastShow('error', t('error'), err.toString(), '', err.response));
  };

  let loadSupplierItemsTimeout = null;
  const loadSupplierItems = () => {
    if (!purchaseOrderSupplierId) return;
    setLoadingSupplierItems(true);
    if (loadSupplierItemsTimeout) {
      clearTimeout(loadSupplierItemsTimeout);
    }
    loadSupplierItemsTimeout = setTimeout(() => {
      const params = {
        ...lazyParamsSupplierItems,
        filters: {
          ...(lazyParamsSupplierItems.filters || {}),
          purchase_order_supplier: { value: purchaseOrderSupplierId, matchMode: 'equals' }
        }
      };
      let query = window.App.transformQueryParams(params);
      apiCall('get', '/api/v2/purchase-order-supplier-item' + query)
        .then(response => {
          setTotalRecordsSupplierItems(response.data.data.total_item_count);
          setSupplierItems(response.data.data.items);
          window.App.setState({ hasSupplierItems: response.data.data.total_item_count > 0 })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingSupplierItems(false);
        })
    }, Math.random() * 1000 + 250);
  };

  const copyVatToItems = async (fromIndex, value) => {
    if (value === null || value === undefined || value === '') return;
    if (!Array.isArray(supplierItems) || supplierItems.length === 0) return;

    const targetIndexes = supplierItems
      .map((_, i) => i)
      .filter(i => i !== fromIndex);
    if (targetIndexes.length === 0) return;

    setLoadingGlobal(true);
    setSupplierItems(prev => {
      const next = [...prev];
      for (const i of targetIndexes) {
        next[i] = { ...next[i], vat_rate: value };
      }
      return next;
    });
    try {
      const requests = targetIndexes.map(i =>
        apiCall('patch', `/api/v2/purchase-order-supplier-item/${supplierItems[i].id}`, {
          vat_rate: value
        })
      );
      await Promise.all(requests);
      window.App.toastShow('success', t('copySuccess'));
    } catch (err) {
      window.App.toastShow('error', t('toastError'), err.toString(), '', err.response);
      loadSupplierItems();
    } finally {
      setLoadingGlobal(false);
    }
  };

  const handleDragStart = (event, item) => {
    if (!canEdit) return;
    let draggedItems = [item];
    if (Array.isArray(selectedPoItems) && selectedPoItems.length > 0) {
      const isPartOfSelection = selectedPoItems.some(sel => sel.id === item.id);
      if (isPartOfSelection) {
        draggedItems = selectedPoItems;
      }
    }
    const draggedIds = draggedItems.map(i => i.id);
    const payload = {
      source: 'poItems',
      ids: draggedIds
    };
    setDraggingPoItemIds(draggedIds);
    event.dataTransfer.setData("application/json", JSON.stringify(payload));
    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragEnd = () => {
    setDraggingPoItemIds([]);
    setDragOverSupplierTable(false);
  };

  const handleDrop = async (event, target) => {
    event.preventDefault();
    setDragOverSupplierTable(false);
    if (!canEdit) return;
    // if (ordered) return;

    if (target === "right") {
      if (!purchaseOrderSupplierId) return;
      let payload = null;
      const raw =
        event.dataTransfer.getData("application/json") ||
        event.dataTransfer.getData("text/plain");
      if (!raw) return;
      try {
        payload = JSON.parse(raw);
      } catch (e) {
        return;
      }
      let ids = [];
      if (payload && Array.isArray(payload.ids)) {
        ids = payload.ids;
      } else if (payload && payload.id) {
        ids = [payload.id];
      } else if (Array.isArray(payload)) {
        ids = payload;
      }
      if (!ids || ids.length === 0) return;
      const itemsToAdd = poItems.filter(item => ids.includes(item.id)).reverse();
      if (itemsToAdd.length === 0) return;
      const delay = (ms) => new Promise(res => setTimeout(res, ms));
      setLoadingGlobal(true);
      setLoadingSupplierItems(true);
      try {
        for (let i = 0; i < itemsToAdd.length; i++) {
          const droppedItem = itemsToAdd[i];
          await apiCall('post', '/api/v2/purchase-order-supplier-item', {
            purchase_order_supplier: Number(purchaseOrderSupplierId),
            purchase_order_item: droppedItem.id,
          });
          if (i < itemsToAdd.length - 1) {
            await delay(10);
          }
        }
        window.App.toastShow('success', t('toastSuccess'));
        window.App.setState({ rerenderPurchaseorderSupplierForm: Math.random(), rerenderPurchaseorderSupplierList: Math.random(), rerenderPurchaseorderShow: Math.random() });
        loadPoItems();
        loadSupplierItems();
      } catch (error) {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      } finally {
        setLoadingGlobal(false);
        setDraggingPoItemIds([]);
        setDragOverSupplierTable(false);
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const updateSupplierItemField = (rowId, fieldName, value) => {
    const el = document.getElementById(`${fieldName}_${rowId}`);
    const target = el?.querySelector('.p-inputtext') || el;
    if (target) target.style.background = "#ffc107";
    if (target) target.style.color = "white";
    if (!canEdit || !rowId) return;
    if (!window.supplierItemTimeout) {
      window.supplierItemTimeout = {};
    }
    const timeoutKey = `${rowId}_${fieldName}`;
    if (window.supplierItemTimeout[timeoutKey]) {
      clearTimeout(window.supplierItemTimeout[timeoutKey]);
    }
    window.supplierItemTimeout[timeoutKey] = setTimeout(() => {
      setLoadingGlobal(true);
      apiCall('patch', `/api/v2/purchase-order-supplier-item/${rowId}`, {
        [fieldName]: value
      })
        .then(response => {
          if (target) {
            target.style.background = "#28a745";
            target.style.color = "white";
          }
          loadPoItems();
          window.App.setState({ rerenderPurchaseorderSupplierList: Math.random(), rerenderPurchaseorderShow: Math.random() });
        })
        .catch(error => {
          if (target) {
            target.style.background = "red";
            target.style.color = "white";
          }
          loadSupplierItems();
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingGlobal(false);
          delete window.supplierItemTimeout[timeoutKey];
        });
    }, 400);
  };

  const deleteSupplierItem = (rowData) => {
    if (!canEdit || !rowData?.id) {
      return;
    }
    if (!window.confirm('A törlés megerősítésére van szükség!')) {
      return;
    }
    setLoadingGlobal(true);
    apiCall('delete', '/api/v2/purchase-order-supplier-item/' + rowData.id)
      .then(() => {
        window.App.toastShow('success', 'Sikeres törlés!');
        setSupplierItems(prev => prev.filter(item => item.id !== rowData.id));
        setTotalRecordsSupplierItems(prev => Math.max(0, Number(prev || 0) - 1));
        window.App.setState({
          rerenderPurchaseorderSupplierForm: Math.random(),
          rerenderPurchaseorderSupplierList: Math.random(),
          rerenderPurchaseorderShow: Math.random(),
          hasSupplierItems: supplierItems.length > 1
        });
        loadPoItems();
        loadSupplierItems();
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoadingGlobal(false);
      });
  };

  useEffect(() => {
    if (!purchaseOrderSupplierId) return;
    setLoadingGlobal(true);
    apiCall('get', '/api/v2/purchase-order-supplier/' + purchaseOrderSupplierId)
      .then(response => {
        const data = response.data.data;
        setSupplierOrder(data);
        setOrdered(!!data.ordered);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoadingGlobal(false);
      });
  }, [purchaseOrderSupplierId, t, window.App.state?.rerenderPurchaseorderSupplierForm]);

  useEffect(() => {
    const _vatQuery = { rows: 9999 };
    const vatQuery = window.App.transformQueryParams(_vatQuery);
    apiCall('get', '/api/v2/vat-rate' + vatQuery)
      .then(response => {
        setVatRates(response.data.data.items || response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [t]);

  useEffect(() => {
    if (!purchaseOrderId) return;
    apiCall('get', `/api/v2/purchase-order/${purchaseOrderId}`)
      .then(res => {
        const po = res.data.data;
        const pid = po?.project?.id || po?.project || null;
        setPurchaseOrderProjectId(pid);
        if (pid) loadProjectItems(pid);
      })
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
  }, [purchaseOrderId]);

  useEffect(() => {
    if (purchaseOrderId) {
      loadPoItems();
    }
  }, [lazyParamsPoItems, purchaseOrderId, window.App.state?.rerenderPurchaseorderitemList]);

  useEffect(() => {
    if (purchaseOrderSupplierId) {
      window.App.setState({ hasSupplierItems: false }); 
      loadSupplierItems();
    } else {
      window.App.setState({ hasSupplierItems: false });
    }
  }, [lazyParamsSupplierItems, purchaseOrderSupplierId, window.App.state?.rerenderPurchaseorderSupplierForm]);

  const renderDraggableCell = (rowData, content) => (
    <div
      draggable={canEdit}
      style={{ cursor: canEdit ? 'move' : 'default' }}
      onDragStart={(e) => handleDragStart(e, rowData)}
      onDragEnd={handleDragEnd}
    >
      {content}
    </div>
  );

  return (
    <div className={"purchaserequest-dnd widget"}>
      {loadingGlobal &&
        <ProgressBar
          mode="indeterminate"
          style={{ height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0 }}
        />
      }
      {isReadMode && (
        <div className="p-grid p-mb-3">
          <div className="p-col-12 p-lg-6">
            <div className="p-field p-fluid">
              <label>{t('fieldSupplier')}</label>
              <span className="p-d-block fake-input">
                {supplierOrder?.partner?.name || '-'}
              </span>
            </div>
          </div>
        </div>
      )}
      <div className={"p-grid"}>
        {!viewOnly && (
          <div
            className={"p-col-12 p-lg-6"}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, "left")}
          >
            <Panel>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('procurementItems')}
                  </h3>
                </div>
              </div>
              <DataTable
                emptyMessage={t('noResults')}
                size={"small"}
                value={poItems}
                paginator
                first={lazyParamsPoItems.first}
                totalRecords={totalRecordsPoItems}
                onPage={onPagePoItems}
                onSort={onSortPoItems}
                sortField={lazyParamsPoItems.sortField}
                sortOrder={lazyParamsPoItems.sortOrder}
                onFilter={onFilterPoItems}
                filters={lazyParamsPoItems.filters}
                lazy
                paginatorTemplate={pagerPoItems}
                rows={rowsPoItems}
                autoLayout={true}
                filterDisplay="row"
                responsiveLayout="scroll"
                stripedRows
                ref={dtPoItems}
                dataKey="id"
                loading={loadingPoItems}
                selection={selectedPoItems}
                onSelectionChange={(e) => setSelectedPoItems(e.value)}
                rowClassName={(rowData) =>
                  Array.isArray(draggingPoItemIds) && draggingPoItemIds.includes(rowData.id)
                    ? 'dnd-drag-source-row-active'
                    : 'dnd-drag-source-row'
                }
              >
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: '3rem' }}
                />
                <Column
                  field="material.name"
                  header={t('columnName')}
                  sortable
                  filter
                  body={(rowData) =>
                    renderDraggableCell(rowData, rowData?.material?.name)
                  }
                />
                {/* <Column
                  field="quantity"
                  header={t('columnQuantity')}
                  sortable
                  filter
                  className={"p-text-right"}
                  body={(rowData) =>
                    renderDraggableCell(rowData, `${Number(rowData?.quantity)} ${rowData?.unit?.name || ''}`)
                  }
                /> */}
                <Column field="quantity" header={t('columnRequested')} sortable filter body={(rowData) => renderDraggableCell(rowData, `${rowData?.quantity} ${rowData?.unit?.name || ''}`)}></Column>
                <Column field="quantity_ordered" header={t('columnOrdered')} sortable filter body={(rowData) => renderDraggableCell(rowData, `${rowData?.quantity_ordered || 0} ${rowData?.unit?.name || ''}`)}></Column>
                <Column field="quantity_received" header={t('columnReceived')} sortable filter body={(rowData) => renderDraggableCell(rowData, `${rowData?.quantity_received || 0} ${rowData?.unit?.name || ''}`)}></Column>
                <Column header={t('columnWaitingForProcurement')} sortable filter body={(rowData) => {
                  const qty = Number(rowData?.quantity || 0);
                  const ordered = Number(rowData?.quantity_ordered || 0);
                  const waiting = Math.max(0, qty - ordered);
                  return renderDraggableCell(
                    rowData,
                    `${waiting} ${rowData?.unit?.name || ''}`.trim()
                  );
                }}></Column>
                {/* <Column
                  field="unit.name"
                  header={t('columnUnit2')}
                  sortable
                  filter
                  body={(rowData) =>
                    renderDraggableCell(rowData, rowData?.unit?.name)
                  }
                /> */}
              </DataTable>
            </Panel>
          </div>
        )}
        <div
          className={"p-col-12 " + (!viewOnly ? 'p-lg-6' : '')}
          onDragOver={(e) => {
            e.preventDefault();
            if (canEdit && draggingPoItemIds.length > 0) {
              setDragOverSupplierTable(true);
            }
          }}
          onDragLeave={(e) => {
            const related = e.relatedTarget;
            if (!e.currentTarget.contains(related)) {
              setDragOverSupplierTable(false);
            }
          }}
          onDrop={(e) => handleDrop(e, "right")}
        >
          <Panel>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('supplierOrderItems')}
                </h3>
              </div>
            </div>
            <DataTable
              emptyMessage={t('noResults')}
              size={"small"}
              value={supplierItems}
              paginator
              first={lazyParamsSupplierItems.first}
              totalRecords={totalRecordsSupplierItems}
              onPage={onPageSupplierItems}
              onSort={onSortSupplierItems}
              sortField={lazyParamsSupplierItems.sortField}
              sortOrder={lazyParamsSupplierItems.sortOrder}
              onFilter={onFilterSupplierItems}
              filters={lazyParamsSupplierItems.filters}
              lazy
              paginatorTemplate={pagerSupplierItems}
              rows={rowsSupplierItems}
              autoLayout={true}
              filterDisplay="row"
              responsiveLayout="scroll"
              stripedRows
              ref={dtSupplierItems}
              dataKey="id"
              loading={loadingGlobal || loadingSupplierItems}
            >
              <Column
                field="material.name"
                header={t('columnName')}
                sortable
                filter
                body={(rowData) => rowData?.material?.name}
              />
              <Column
                header={t('columnQuantity')}
                sortable
                className={"p-text-right"}
                body={(rowData) => {
                  if (!canEdit) {
                    return <>{Number(rowData?.quantity)} {rowData?.unit?.name}</>;
                  }
                  return (
                    <div className="p-d-flex p-jc-end p-ai-center" style={{ gap: 4 }}>
                    <InputNumber
                      minFractionDigits={0}
                      maxFractionDigits={9}
                      locale="hu-HU"
                      id={'quantity_' + rowData.id}
                      value={rowData.quantity}
                      className={"p-inputtext-sm p-text-right"}
                      disabled={!canEdit}
                      onKeyUp={(e) => {
                        const rawValue = e.target.value.replace(/\s/g, '').replace(',', '.');
                        const val = parseFloat(rawValue);
                        if (window.timerSupplierItems) {
                          clearTimeout(window.timerSupplierItems);
                        }
                        window.timerSupplierItems = setTimeout(() => {
                          setSupplierItems(prev =>
                            prev.map(item =>
                              item.id === rowData.id ? { ...item, quantity: val } : item
                            )
                          );
                          updateSupplierItemField(rowData.id, 'quantity', val);
                          }, 1500);
                      }}
                      onValueChange={(e) => {
                        const val = e.value;
                        setSupplierItems(prev =>
                          prev.map(item =>
                            item.id === rowData.id ? { ...item, quantity: val } : item
                          )
                        );
                        updateSupplierItemField(rowData.id, 'quantity', val);
                        clearTimeout(window.timerSupplierItems);
                      }}
                    />
                    {rowData?.unit?.name && (
                      <span style={{ whiteSpace: 'nowrap' }}>
                        {rowData.unit.name}
                      </span>
                    )}
                  </div>
                  )
                }}
              />
              {/* <Column field="quantity_ordered" header={t('columnOrdered')} sortable filter body={(rowData) => rowData?.quantity_ordered}></Column>
              <Column field="quantity_received" header={t('columnReceived')} sortable filter body={(rowData) => rowData?.quantity_received}></Column> */}


              {/* <Column header={t('columnProjectItem')} body={projectItemBodyTemplate}></Column> */}


              {/* <Column
                field="unit.name"
                header={t('columnUnit2')}
                sortable
                filter
                body={(rowData) => rowData?.unit?.name}
              /> */}
              <Column
                header={t('columnUnitPrice')}
                body={(rowData) => {
                  if (!canEdit) {
                    return <>{rowData?.unit_price != null ? rowData.unit_price : ''}</>;
                  }
                  return (
                    <InputNumber
                      minFractionDigits={0}
                      maxFractionDigits={9}
                      locale="hu-HU"
                      id={'unit_price_' + rowData.id}
                      value={rowData.unit_price}
                      className={"p-inputtext-sm p-text-right"}
                      disabled={!canEdit}
                      onKeyUp={(e) => {
                        const rawValue = e.target.value.replace(/\s/g, '').replace(',', '.');
                        const val = parseFloat(rawValue);
                        if (window.timerSupplierItems) {
                          clearTimeout(window.timerSupplierItems);
                        }
                        window.timerSupplierItems = setTimeout(() => {
                          setSupplierItems(prev =>
                            prev.map(item =>
                              item.id === rowData.id ? { ...item, unit_price: val } : item
                            )
                          );
                          updateSupplierItemField(rowData.id, 'unit_price', val);
                        }, 1500);
                      }}
                      onValueChange={(e) => {
                        const val = e.value;
                        setSupplierItems(prev =>
                          prev.map(item =>
                            item.id === rowData.id ? { ...item, unit_price: val } : item
                          )
                        );
                        updateSupplierItemField(rowData.id, 'unit_price', val);
                        clearTimeout(window.timerSupplierItems);
                      }}
                    />
                  )
                }}
              />
              <Column
                header={t('columnVat')}
                body={(rowData, { rowIndex }) => {
                  const currentValue = rowData?.vat_rate?.id || rowData?.vat_rate;
                  if (!canEdit) {
                    const label =
                      vatRates.find(v => v.id === currentValue)?.label ||
                      rowData?.vat_rate?.label ||
                      '';
                    return <>{label}</>;
                  }
                  return (
                    <span className="p-inputgroup">
                      <Dropdown
                        id={'vat_rate_' + rowData.id}
                        value={currentValue}
                        options={vatRates}
                        optionLabel="label"
                        optionValue="id"
                        onChange={(e) => {
                          const val = e.value;
                          setSupplierItems(prev =>
                            prev.map(item =>
                              item.id === rowData.id ? { ...item, vat_rate: val } : item
                            )
                          );
                          updateSupplierItemField(rowData.id, 'vat_rate', val);
                          clearTimeout(window.timerSupplierItems);
                        }}
                        disabled={!canEdit}
                        className={"p-inputtext-sm"}
                        emptyMessage={t('noVatYet')}
                      />
                      <Button
                        type="button"
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm"
                        title="ÁFA másolása minden tételre"
                        disabled={!canEdit || !currentValue}
                        onClick={() => copyVatToItems(rowIndex, currentValue)}
                      />
                    </span>
                  )
                }}
              />
              <Column
                body={(rowData) => {
                  if (!canEdit) {
                    return null;
                  }
                  return (
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      className="p-button-sm p-button-danger"
                      tooltip={t('delete')}
                      tooltipOptions={{ position: 'left' }}
                      disabled={!canEdit}
                      onClick={() => deleteSupplierItem(rowData)}
                    />
                  );
                }}
                className="p-py-0 p-text-right p-text-nowrap"
                style={{ width: '4rem' }}
              />
            </DataTable>
          </Panel>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(PurchaseorderSupplierDndComponent);
